import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "../features/user/userSlice";
import templateReducer from "../features/template/templateSlice";

import departmentReducer from "../features/department/departmentSlice";
import designationReducer from "../features/designation/designationSlice"
import appraisalReducer from "../features/appraisal/appraisalSlice";

const rootReducer = combineReducers({
  userState: userReducer,
  templateState: templateReducer,
  appraisalState: appraisalReducer,
  departmentState: departmentReducer,
  designationState: designationReducer,
});

export default rootReducer;
